import { Swiper } from 'swiper';

export class ProductImagesThumbs {
	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	private sliderSettings = () => ({
		slidesPerView: 'auto',
		spaceBetween: 4,
		breakpoints: {
			700: {
				direction: 'vertical',
			}
		},
	});
	public slider: Swiper;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.sliderElement = this.element.querySelector('.product-images-thumbs__slider');

		this.init();
	}

	public init = ():void => {
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
	};
}
